export enum TemplateView {
  Editor = 'editor',
  Preview = 'preview',
  MobileApps = 'mobile-apps',
  Settings = 'settings',
  HeaderFooter = 'header-footer',
}
